// extracted by mini-css-extract-plugin
module.exports = {"player":"ArticleDetail_ArticleHeaderVideo_player"};